    <app-sidemenu (searchSelected)="searchSelected($event)" [items]="businessMenuItems" [image]="image" [name]="name" [buttontext]="buttontext" (onClick)="switch()">
        <router-outlet></router-outlet>
    </app-sidemenu>